import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import {
  Accordion,
  AccordionPanel,
} from '@unlikelystudio/react-abstract-components'

import { MinusIcon, PlusIcon } from '~/components/Abstracts/Icons'
import ShopifyRichText from '~/components/Abstracts/ShopifyRichText'

import { useStyle } from '~/providers/StyleProvider'

import { GENERAL } from '~/data/dictionary'

import { ProductHeaderAccordionItem } from '../types'
import css from './styles.module.scss'

const cx = classnames.bind(css)

interface ProductAccordionProps {
  className?: string
  accordions: ProductHeaderAccordionItem[]
  index?: number
  children?: JSX.Element | JSX.Element[]
}

function ProductAccordion({
  className,
  accordions,
  index,
  children,
}: ProductAccordionProps) {
  const t = useTranslate()
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Haffer,
    color: GlobalThemeColors.Black,
    textStyling: GlobalTextStyling.UpperCase,
  })
  const textStyle = useStyle({
    textPreset: [
      GlobalTextPreset.Text12Haffer,
      GlobalTextPreset.DefaultRichText,
    ],
    color: GlobalThemeColors.DoveGray,
  })

  return accordions ? (
    <Accordion className={cx(className, css.ProductAccordion)} index={index}>
      {accordions?.map(({ title, text }, index) => (
        <AccordionPanel
          ariaLabels={{
            open: t(GENERAL.ACCORDION_OPEN),
            close: t(GENERAL.ACCORDION_CLOSE),
          }}
          index={index}
          className={css.accordionPanel}
          key={`accordion_panel_${index}`}
          head={(isActive: boolean) => {
            return (
              <div
                className={cx(css.panelHead, titleStyle, {
                  isActive,
                })}>
                <ShopifyRichText className={css.title} render={title} />
                {isActive ? (
                  <MinusIcon className={css.icon} fill="#000000" />
                ) : (
                  <PlusIcon className={css.icon} fill="#000000" />
                )}
              </div>
            )
          }}
          body={
            <>
              <ShopifyRichText
                className={cx(css.panelBody, textStyle)}
                render={text}
                ctaPreset={GlobalTextPreset.Cta12Haffer}
                uppercaseLink={false}
              />
              {index === 0 && children}
            </>
          }
        />
      ))}
    </Accordion>
  ) : null
}

export default ProductAccordion
